angular.module('dnecom')
    .controller('MockupDesignGalleryModalController', ["$scope", "$http", "$uibModalInstance", "notifications", "MediaUtils", "StoreUtils", "designs", "locations", "mockup", "$filter", "$rootScope", function MockupDesignGalleryModalController(
            $scope, $http,
            $uibModalInstance, notifications, MediaUtils, StoreUtils, designs, locations, mockup, $filter, $rootScope) {
        $scope.selectedDesign = null;
        $scope.designName = '';
        $scope.displayLocation = '';
        $scope.filter = 'all';
        $scope.designs = angular.copy(designs);
        $scope.activeTab = 'upload';
        $scope.deleting = false;
        $scope.uploading = false;
        $scope.uploadingProgress = 0;
        $scope.locations = {};
        $scope.search = {
            name: ''
        };

        $scope.init = function () {
            _.forEach(locations, function (value, key) {
                $scope.locations[key] = capitalize(key);
            });

            if ($scope.designs.length > 0 || $scope.hasAssignments()) {
                $scope.activeTab = 'gallery';

                _.forEach(mockup.designs, function(mockupDesign) {
                    _.forEach($scope.designs, function(design) {
                        if (design.id == mockupDesign.designId) {
                            design.location = mockupDesign.location;
                            design.mdId = mockupDesign.id;
                        }
                    });
                });

                for (var i = 0; i < $scope.designs.length; i++) {
                    if ($scope.designs[i].active) {
                        $scope.selectedDesign = $scope.designs[i];
                        $scope.displayLocation = $scope.selectedDesign.location;
                        $scope.designName = $scope.selectedDesign.name;
                        return;
                    }
                }
            }
        };

        $scope.$watch('mediaFiles', function () {
            upload($scope.mediaFiles);
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };

        $scope.confirm = function () {
            var designs = [];

            _.forEach($scope.designs, function(design) {
                if (design.location) {
                    var item = {
                        designId: design.id,
                        name:     design.name,
                        location: design.location,
                        media:    design.media,
                    };

                    if (design.mdId) {
                        item.id = design.mdId;
                    }

                    designs.push(item);
                }
            });

            $rootScope.$broadcast('designs.update', $scope.designs);

            $uibModalInstance.close(designs);
        };

        $scope.closeSidebar = function () {
            $scope.selectedDesign.active = false;
            $scope.selectedDesign = null;
            $scope.designName = '';
        };

        $scope.openSidebar = function (design) {
            // Reset active state on previous design
            if (!_.isNull($scope.selectedDesign)) {
                $scope.selectedDesign.active = false;
            }

            // Assign new selected design
            $scope.selectedDesign = design;
            $scope.selectedDesign.active = true;
            $scope.displayLocation = design.location;
            $scope.designName = design.name;
        };

        $scope.filterAssignedLocations = function (locations) {
            var filtered = {};

            _.forEach(locations, function (value, key) {
                for (var i = 0; i < $scope.designs.length; i++) {
                    if (key === $scope.designs[i].location) {
                        return;
                    }
                }

                filtered[key] = value;
            });

            // Assign selected option
            if ($scope.displayLocation && $scope.displayLocation.length > 0) {
                filtered[$scope.displayLocation] = $scope.locations[$scope.displayLocation];
            }

            return filtered;
        };

        $scope.assignLocation = function () {
            $scope.selectedDesign.location = $scope.displayLocation;
        };

        $scope.assignName = function () {
            if (!_.isNull($scope.selectedDesign)) {
                $scope.selectedDesign.name = $scope.designName;
            }
        };

        $scope.removeLocation = function (design, $event) {
            $event.preventDefault();
            design.location = '';

            if (design.active) {
                $scope.displayLocation = '';
            }
        };

        $scope.clearSelection = function ($event) {
            $event.preventDefault();

            _.forEach($scope.designs, function (value) {
                value.location = '';
            });

            if (!_.isNull($scope.selectedDesign)) {
                $scope.displayLocation = '';
            }
        };

        $scope.hasAssignments = function () {
            return $filter('removeEmpty')($scope.designs, 'location').length > 0;
        };

        $scope.selectFilter = function () {
            switch ($scope.filter) {
                case 'all':
                    delete $scope.search.location;
                    break;

                case 'assigned':
                    $scope.search.location = '!';
                    break;

                case 'unassigned':
                    $scope.search.location = '';
                    break;
            }
        };

        $scope.switchTabs = function (tab) {
            $scope.activeTab = tab;
        };

        $scope.deleteDesign = function () {
            $scope.deleting = true;

            $http
                .post(Routing.generate('mockup_delete_design', { id: $scope.selectedDesign.id }))
                .then(function (result) {
                    if (result.data.success) {
                        for (var i = 0; i < $scope.designs.length; i++) {
                            if ($scope.designs[i].id === $scope.selectedDesign.id) {
                                $scope.designs.splice(i, 1);
                            }
                        }

                        $rootScope.$broadcast('designs.update', $scope.designs);

                        notifications.success('Design successfully deleted');
                    } else {
                        notifications.danger('Error deleting design');
                    }

                    $scope.deleting = false;
                    $scope.closeSidebar();

                    if ($scope.designs.length === 0) {
                        $scope.switchTabs('upload');
                    }
                }, function (error) {
                    notifications.danger('Request error');
                    $scope.deleting = false;
                })
            ;
        };

        var upload = function (files) {
            if (!files || !files.length) {
                return false;
            }

            var uploaded = 0;
            var max = files.length;

            $scope.uploading = true;
            $scope.uploadingProgress = 0;

            for (var i = 0; i < files.length; i++) {
                StoreUtils.upload(null, files[i], function (response) {
                    $http.post(Routing.generate('mockup_create_design'), {
                        name: response.fileName.replace(/\..+/, ''), // drop file extension (eg. ".jpg")
                        mediaId: response.id
                    }).then(function (result) {
                        if (!result.data.success) {
                            notifications.danger('Failed to create design.');
                            return;
                        }

                        uploaded += 1;

                        $scope.designs.push(result.data.design);
                        $scope.uploadingProgress = (uploaded / max) * 100;

                        // Check if last design has been uploaded
                        if (uploaded == files.length) {
                            $scope.activeTab = 'gallery';
                            $scope.uploading = false;
                            $scope.uploadingProgress = 100;

                            notifications.success(uploaded + ' files have been successfully uploaded');
                        }

                        $rootScope.$broadcast('designs.update', $scope.designs);
                    }, function (error) {
                        notifications.danger('Request error');
                    });
                }, false);
            }
        };

        var capitalize = function (input) {
            return input.toString().charAt(0).toUpperCase() + input.toString().slice(1);
        };
    }]);
